<template>
<div></div>
</template>

<script>
export default {
  created: function () {
    this.$store.commit("setProject", {
      project: {
        form_hash: this.$route.params.formHash
      },
    });
    this.$router.push("/personal-data");
  }
};
</script>

<style>
</style>
